import React from 'react';
import { Edit } from 'react-admin';
import { t } from 'i18next';

import { CustomEditToolbar } from '../CustomEditToolbar';
import EditFormTitle from '../EditFormTitle';
import { AgeGroupCatForm } from './AgeGroupCatForm';

export const AgeGroupCatEdit = props => (
  <Edit {...props} title={<EditFormTitle formName={t('age_group.cat_title')}/>}>
    <AgeGroupCatForm toolbar={<CustomEditToolbar user={props.options.currentUser.role}/>}/>
  </Edit>
);